import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui components

import buttonStyle from "../../../assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";
import CircularProgress from "@material-ui/core/es/CircularProgress/CircularProgress";
import Button from "@material-ui/core/es/Button/Button";
import withStyles from "@material-ui/core/es/styles/withStyles";

function RegularButton({...props}) {
    const {
        classes,
        color,
        round,
        children,
        fullWidth,
        disabled,
        loading,
        simple,
        size,
        block,
        link,
        justIcon,
        className,
        muiClasses,
        ...rest
    } = props;
    const btnClasses = classNames({
        [classes.button]: true,
        [classes[size]]: size,
        [classes[color]]: color,
        [classes.round]: round,
        [classes.fullWidth]: fullWidth,
        [classes.disabled]: disabled,
        [classes.simple]: simple,
        [classes.block]: block,
        [classes.link]: link,
        [classes.justIcon]: justIcon,
        [className]: className
    });
    const loadingClasses = classNames({
        [classes.loadingContainerSimple]: simple,
        [classes.loadingContainer]: true,
    });
    return (
        <Button {...rest} classes={muiClasses} className={btnClasses}>
            {loading ?
                <div className={loadingClasses}>
                    <CircularProgress size={16} color="inherit"/>
                </div> :
                children}
        </Button>
    );
}

export default withStyles(buttonStyle, {withTheme: true})(RegularButton);



// WEBPACK FOOTER //
// ./src/components/material-pro/CustomButtons/Button.jsx